import { motion } from 'framer-motion';
import styled from 'styled-components';

import { styledLayout } from '@pkg/primitives';

export const Wrapper = styled(motion.div)`
    flex-shrink: 0;
    overflow: hidden;
    position: sticky;
    top: 95px;
    height: 100%;
    @media (max-width: 768px) {
        height: unset;
    }
    --yat_scrollbar-thumb-color: ${({ theme }) => theme.shades.purple['20']};

    ${styledLayout.scrollbar({
        thumbColor: 'var(--yat_scrollbar-thumb-color)',
        trackColor: 'transparent',
    })};
`;

export const Divider = styled.div`
    width: 100%;
    height: 1px;
    background-color: rgba(255, 255, 255, 0.1);
`;

export const FiltersList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 20px;

    width: 276px;
    max-height: calc(100vh - 120px);
    flex-shrink: 0;
    overflow-y: auto;
    @media (max-width: 768px) {
        width: 100%;
    }
`;

export const OptionGrid = styled.div`
    display: flex;
    gap: 10px 5px;
    flex-wrap: wrap;
`;
